import { supabase } from '@/lib/supabase';

export interface PageSection {
  id: string;
  pageKey: string;
  sectionKey: string;
  label: string;
  image?: string;
  title?: string;
  subtitle?: string;
  content?: string;
}

interface DbRow {
  id: string;
  page_key: string;
  section_key: string;
  label: string;
  image: string | null;
  title: string | null;
  subtitle: string | null;
  content: string | null;
}

function rowToSection(row: DbRow): PageSection {
  return {
    id: row.id,
    pageKey: row.page_key,
    sectionKey: row.section_key,
    label: row.label,
    image: row.image ?? undefined,
    title: row.title ?? undefined,
    subtitle: row.subtitle ?? undefined,
    content: row.content ?? undefined,
  };
}

export const DEFAULT_PAGE_CONTENT: PageSection[] = [
  {
    id: 'home-hero',
    pageKey: 'home',
    sectionKey: 'hero',
    label: '首頁 Hero 橫幅',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/home-hero-bg.jpg',
    title: '專業手機維修，值得信賴的選擇',
    subtitle: '超過 15 年維修經驗，原廠規格零件，30 分鐘快速維修，終身保固服務',
  },
  {
    id: 'home-about',
    pageKey: 'home',
    sectionKey: 'about',
    label: '首頁 關於我們區塊',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/home-about-img.jpg',
    content: '兄弟維修成立於 2021 年，核心維修工程師擁有 15 年以上實務經驗，技術涵蓋 iPhone 全系列、Samsung、Google Pixel 等各大品牌，並取得 Apple IRP 獨立維修中心認證。',
  },
  {
    id: 'about-banner',
    pageKey: 'about',
    sectionKey: 'banner',
    label: '關於我們 頂部橫幅',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/about-banner-bg.jpg',
    title: '關於兄弟手機維修',
    subtitle: '成立於 2021 年，技術深度超越年份。實戰累積，不靠話術。',
  },
  {
    id: 'about-story-v2',
    pageKey: 'about',
    sectionKey: 'story',
    label: '關於我們 品牌故事（長文）',
    content: '兄弟手機維修成立於 2021 年。創立時間不長，但技術累積並不短。核心維修工程師擁有 15 年以上實務經驗，從早期功能型手機、智慧型手機初代機型，到現代高整合主機板架構，一路參與並熟悉硬體演進。我們的基礎不建立在話術，而建立在長期維修實戰。\n\n累積超過萬台以上設備維修經驗，涵蓋 iPhone 全系列、Samsung Galaxy、Google Pixel 及各大 Android 品牌，同時具備主機板級維修與精密焊接能力。大量案例的價值不在於數字，而在於對故障邏輯的判斷精準度——我們清楚哪些問題常見，也清楚哪些狀況不能草率處理。\n\n除門市服務外，亦承接全台同業代工維修，包含主機板層級故障排除、短路檢測、電源 IC 修復、進水腐蝕處理與高難度焊接作業。當一般維修單位無法處理時，會轉交由我們進行技術修復。這代表的不是規模，而是信任。同時，我們亦不定期接收海外寄修案件，跨國維修流程採標準化作業與完整測試，確保每一台設備穩定交付。',
  },
  {
    id: 'iphone-banner',
    pageKey: 'iphone',
    sectionKey: 'banner',
    label: 'iPhone 維修 頂部橫幅',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/iphone-banner-bg.jpg',
    title: 'iPhone 維修',
    subtitle: 'iPhone 6S 至 iPhone 16 系列全機型服務',
  },
  {
    id: 'ipad-banner',
    pageKey: 'ipad',
    sectionKey: 'banner',
    label: 'iPad 維修 頂部橫幅',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/ipad-banner-bg.jpg',
    title: 'iPad 維修',
    subtitle: 'iPad Pro / Air / Mini 全系列服務',
  },
  {
    id: 'mac-banner',
    pageKey: 'mac',
    sectionKey: 'banner',
    label: 'Mac 維修 頂部橫幅',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/mac-banner-bg.jpg',
    title: 'Mac 維修',
    subtitle: 'MacBook Air / Pro 全系列，含 M 系列晶片',
  },
  {
    id: 'cases-banner',
    pageKey: 'cases',
    sectionKey: 'banner',
    label: '維修案例 頂部橫幅',
    title: '維修案例分享',
    subtitle: '真實維修案例記錄，展示我們的技術能力與維修成果',
  },
  {
    id: 'contact-banner',
    pageKey: 'contact',
    sectionKey: 'banner',
    label: '聯絡我們 頂部標題',
    title: '與我們聯絡',
    subtitle: '有任何維修問題或需要報價，歡迎透過以下方式聯絡我們',
  },
  {
    id: 'contact-address',
    pageKey: 'contact',
    sectionKey: 'address',
    label: '聯絡資訊 店面地址',
    title: '台北市萬華區萬大路251號',
    subtitle: '近萬大路',
  },
  {
    id: 'contact-phone',
    pageKey: 'contact',
    sectionKey: 'phone',
    label: '聯絡資訊 聯絡電話',
    title: '0916-858-251',
    subtitle: '(02) 2305-1647',
  },
  {
    id: 'contact-hours',
    pageKey: 'contact',
    sectionKey: 'hours',
    label: '聯絡資訊 營業時間',
    title: '週一至週六 13:00–22:00',
    subtitle: '週日及國定假日休息',
  },
];

// ─── Supabase-backed API (v2) ─────────────────────────────────────────────

export async function fetchPageContent(): Promise<PageSection[]> {
  const { data, error } = await supabase
    .from('page_sections')
    .select('*')
    .order('page_key');

  if (error || !data || data.length === 0) {
    return DEFAULT_PAGE_CONTENT;
  }

  // Merge: use DB data, fall back to defaults for any missing ids
  const dbMap = new Map<string, PageSection>(
    (data as DbRow[]).map(row => [row.id, rowToSection(row)])
  );
  return DEFAULT_PAGE_CONTENT.map(def => dbMap.get(def.id) ?? def);
}

export async function upsertSection(section: PageSection): Promise<void> {
  const { error } = await supabase.from('page_sections').upsert(
    {
      id: section.id,
      page_key: section.pageKey,
      section_key: section.sectionKey,
      label: section.label,
      image: section.image ?? null,
      title: section.title ?? null,
      subtitle: section.subtitle ?? null,
      content: section.content ?? null,
      updated_at: new Date().toISOString(),
    },
    { onConflict: 'id' }
  );
  if (error) throw error;
}

// ─── Legacy sync helpers (kept for backward compat, now no-ops) ────────────

export function getPageContent(): PageSection[] {
  return DEFAULT_PAGE_CONTENT;
}

export function savePageContent(_data: PageSection[]): void {
  // no-op: use upsertSection instead
}

export function getPageSections(pageKey: string): PageSection[] {
  return DEFAULT_PAGE_CONTENT.filter(s => s.pageKey === pageKey);
}

export function getSectionById(id: string): PageSection | undefined {
  return DEFAULT_PAGE_CONTENT.find(s => s.id === id);
}

export function updateSection(_updated: PageSection): void {
  // no-op: use upsertSection instead
}
